import { buildStatusMetadataIndex } from "helpers/statusMetadataHelpers";

/** Session-scoped cache so status-metadata is fetched at most once per login. */
let sessionIndex = null;
let sessionLoadPromise = null;

export const getStatusMetadataSessionIndex = () => sessionIndex;

export const setStatusMetadataSessionIndex = (index) => {
  sessionIndex = index;
};

export const getStatusMetadataSessionLoadPromise = () => sessionLoadPromise;

export const setStatusMetadataSessionLoadPromise = (promise) => {
  sessionLoadPromise = promise;
};

export const clearStatusMetadataSessionCache = () => {
  sessionIndex = null;
  sessionLoadPromise = null;
};

export const getEmptyStatusMetadataIndex = () => buildStatusMetadataIndex([]);
